var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 2.3125C27.4401 2.3125 34.6875 9.55989 34.6875 18.5C34.6875 27.4401 27.4401 34.6875 18.5 34.6875C9.55988 34.6875 2.3125 27.4401 2.3125 18.5C2.3125 9.55989 9.55988 2.3125 18.5 2.3125ZM19.3175 13.5363C19.7691 13.0848 19.7691 12.3527 19.3175 11.9012C18.866 11.4496 18.134 11.4496 17.6825 11.9012L11.9012 17.6825C11.4496 18.134 11.4497 18.866 11.9012 19.3175L17.6825 25.0988C18.134 25.5504 18.866 25.5504 19.3175 25.0988C19.7691 24.6472 19.7691 23.9153 19.3175 23.4637L15.5102 19.6563L24.2813 19.6563C24.9198 19.6563 25.4375 19.1386 25.4375 18.5C25.4375 17.8614 24.9198 17.3438 24.2813 17.3438L15.5102 17.3438L19.3175 13.5363Z",
    fill: "#3b3b3b",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.1c15bce99fe0695d11a0f10fbb142e60.svg";
export { ForwardRef as ReactComponent };